import React from "react"
import classNames from "classnames"
import { useParams } from "react-router-dom"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import { useAppContext } from "components/AppContext"

const DataQualitySaasChartOrganism = () => {
  const { pillarId: urlPillarId } = useParams()
  const { envScore } = useAppContext()

  const dashboardAlias = "dashboard_dataquality_saas"

  return (
    <div className="Verdikt-Score">
      <div className={classNames(urlPillarId, "page-frame")}>
        <div className={classNames("page")}>
          <div
            className={classNames(
              urlPillarId,
              "widget",
              "chart",
              "transparent-widget"
            )}
          >
            <MetabaseChartMolecule verdikt_alias={dashboardAlias} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DataQualitySaasChartOrganism
